export default "__VITE_ASSET__7WNbM_9o__"